export default __webpack_public_path__ + "static/media/swifthood-cover.7c2b1e82.jpg";